import script from "./dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=8a04713c&lang=css"
import "./dashboard.vue?vue&type=style&index=1&id=8a04713c&lang=css"

const __exports__ = script;

export default __exports__